import { FaShieldAlt } from "react-icons/fa";
import {
  Container,
  PageHeader,
  ContentSection,
  ContentContainer,
  SectionTitle,
  SubsectionTitle,
  TextContent,
  ImportantNotice,
  LastUpdated,
} from "../TermsOfServicePage/TermsOfServicePage.styles";
import MainContainer from "../../components/MainContainer/MainContainer";
import SEO from "../../components/SEO/SEO";

const PrivacyPolicyPage = () => {
  return (
    <MainContainer>
      <SEO
        title="Politika privatnosti"
        description="Politika privatnosti MITOVKA BeautySpot — kako čuvamo i koristimo vaše podatke."
        path="/politika-privatnosti"
      />

      <Container>
        <PageHeader>
          <h1>Politika Privatnosti</h1>
          <p>
            Vaša privatnost je važna za nas. Ova politika objašnjava kako
            prikupljamo, koristimo i štitimo vaše lične podatke.
          </p>
        </PageHeader>

        <ContentSection>
          <ContentContainer>
            <SectionTitle>1. Prikupljanje Podataka</SectionTitle>
            <SubsectionTitle>1.1 Podaci koje prikupljamo</SubsectionTitle>
            <TextContent>
              <p>
                MITOVKA Beautyspot platforma prikuplja različite vrste podataka
                za potrebe pružanja edukacionih usluga i održavanja
                funkcionalnosti:
              </p>
              <ul>
                <li>
                  <strong>Osnovni lični podaci:</strong> ime, prezime, email
                  adresa, broj telefona (pri registraciji i komunikaciji)
                </li>
                <li>
                  <strong>Podaci o nalogu:</strong> jedinstveni ID korisnika
                  (UUID), enkriptovana lozinka (bcrypt hash), status
                  verifikacije email-a
                </li>
                <li>
                  <strong>Podaci o kursevima:</strong> kupljeni kursevi,
                  napredak učenja, datum upisivanja, status završetka
                </li>
                <li>
                  <strong>Podaci o transakcijama:</strong> istorija plaćanja,
                  iznosi transakcija, datumi kupovine, ID transakcije, podaci o
                  statusu plaćanja preko Raiffeisen Gateway-a (čuvaju se 10
                  godina u skladu sa zakonskim obavezama)
                </li>
                <li>
                  <strong>Podaci za sertifikate:</strong> zahtevi za izdavanje
                  sertifikata, lični podaci potrebni za sertifikaciju
                </li>
                <li>
                  <strong>Komunikacija:</strong> poruke kroz kontakt forme, FAQ
                  upiti
                </li>
                <li>
                  <strong>Tehnički podaci:</strong> IP adresa, tip pretraživača,
                  operativni sistem, vreme poslednje prijave
                </li>
                <li>
                  <strong>Podaci o korišćenju:</strong> vreme provedeno na
                  kursevima, najčešće korišćene funkcije, analitika napredovanja
                </li>
              </ul>
              <p>
                <strong>Napomena o podacima platnih kartica:</strong> MITOVKA
                Beautyspot NE čuva niti obrađuje podatke o vašoj platnoj kartici
                (broj kartice, CVV, datum isteka). Svi podaci o kartičnom
                plaćanju se direktno obrađuju preko Raiffeisen Gateway-a u
                skladu sa PCI DSS standardima bezbednosti.
              </p>
            </TextContent>

            <SubsectionTitle>1.2 Kako prikupljamo podatke</SubsectionTitle>
            <TextContent>
              <p>
                Podatke prikupljamo kroz različite kanale na našoj platformi:
              </p>
              <ul>
                <li>
                  <strong>Registracija korisnika:</strong> ime, prezime, email,
                  telefon kroz registracioni form
                </li>
                <li>
                  <strong>Kupovina kurseva:</strong> podaci o transakcijama
                  preko Raiffeisen Gateway sistema za online plaćanje
                </li>
                <li>
                  <strong>Praćenje napretka:</strong> automatsko beleženje
                  napredovanja kroz kurseve
                </li>
                <li>
                  <strong>Admin dashboard:</strong> analitika korišćenja za
                  poboljšanje usluga
                </li>
                <li>
                  <strong>Kontakt forme:</strong> komunikacija sa korisnicima i
                  tehnička podrška
                </li>
                <li>
                  <strong>Zahtevi za sertifikate:</strong> dodatni lični podaci
                  potrebni za sertifikaciju
                </li>
                <li>
                  <strong>JWT tokeni:</strong> bezbednost sesija i refresh
                  tokeni
                </li>
                <li>
                  <strong>Kolačići:</strong> za funkcionalnost, prepoznavanje
                  korisnika i analitiku
                </li>
              </ul>
            </TextContent>

            <SectionTitle>2. Korišćenje Podataka</SectionTitle>
            <TextContent>
              <p>
                MITOVKA Beautyspot koristi prikupljene podatke isključivo u
                sledeće svrhe:
              </p>
              <ul>
                <li>
                  <strong>Upravljanje nalogom:</strong> kreiranje i održavanje
                  korisničkih profila, autentifikacija, verifikacija email
                  adrese
                </li>
                <li>
                  <strong>Pružanje edukacionih usluga:</strong> pristup
                  kursevima, praćenje napretka, personalizacija sadržaja,
                  izdavanje sertifikata
                </li>
                <li>
                  <strong>Procesiranje transakcija:</strong> obrada kartičnih
                  plaćanja preko Raiffeisen Gateway-a, izdavanje računa, vođenje
                  evidencije kupovina
                </li>
                <li>
                  <strong>Komunikacija:</strong> odgovori na upite, tehnička
                  podrška, obaveštenja o kursevima, potvrde plaćanja, sistemske
                  poruke
                </li>
                <li>
                  <strong>Poboljšanje platforme:</strong> analiza korišćenja
                  kroz admin dashboard, optimizacija korisničkog iskustva,
                  razvoj novih funkcionalnosti
                </li>
                <li>
                  <strong>Bezbednost:</strong> zaštita od neovlašćenog pristupa,
                  prevencija prevara, monitoring sigurnosnih incidenata,
                  detekcija sumnjivih transakcija
                </li>
                <li>
                  <strong>Zakonske obaveze:</strong> ispunjavanje poreskih i
                  računovodstvenih obaveza, odgovaranje na pravne zahteve,
                  arhiviranje transakcija
                </li>
              </ul>
            </TextContent>

            <ImportantNotice>
              <div className="notice-title">
                <FaShieldAlt />
                Bezbednost Podataka
              </div>
              <div className="notice-content">
                Koristimo industrijske standarde za zaštitu vaših podataka,
                uključujući SSL enkripciju, sigurne servere, PCI DSS usklađen
                sistem plaćanja i regularne bezbednosne provere. Vaši podaci o
                platnim karticama se obrađuju direktno preko Raiffeisen
                Gateway-a i nikada ne prolaze kroz naše servere.
              </div>
            </ImportantNotice>

            <SectionTitle>3. Deljenje Podataka</SectionTitle>
            <TextContent>
              <p>
                MITOVKA Beautyspot se obavezuje da neće prodavati, iznajmljivati
                ili komercijalno eksploatisati vaše lične podatke. Deljenje
                podataka vrši se isključivo u sledećim slučajevima:
              </p>
              <ul>
                <li>
                  <strong>Procesiranje plaćanja:</strong> podaci o transakcijama
                  se prosleđuju Raiffeisen banci preko Gateway sistema.
                  Raiffeisen banka obrađuje podatke o kartičnom plaćanju u
                  skladu sa PCI DSS standardima i primenjuje 3D Secure
                  autentifikaciju za dodatnu zaštitu. Podaci o kartici se šalju
                  direktno banci i ne čuvaju se na našim serverima.
                </li>
                <li>
                  <strong>Email komunikacija:</strong> korišćenje email servisa
                  za slanje obaveštenja o kursevima, potvrda plaćanja i podrške
                </li>
                <li>
                  <strong>Cloud hostovanje:</strong> čuvanje podataka na
                  sigurnim serverima sa odgovarajućim bezbednosnim sertifikatima
                </li>
                <li>
                  <strong>Zakonski zahtevi:</strong> kada to zahteva zakon,
                  sudska odluka ili nadležni organi (Poreska uprava, Narodna
                  banka Srbije, sudovi)
                </li>
                <li>
                  <strong>Zaštita prava:</strong> u slučaju kršenja uslova
                  korišćenja, sumnje na zloupotrebe platforme ili prevare u
                  plaćanju
                </li>
              </ul>
            </TextContent>

            <SubsectionTitle>3.1 Treće Strane i Integracije</SubsectionTitle>
            <TextContent>
              <p>MITOVKA Beautyspot platforma koristi sledeće treće strane:</p>
              <ul>
                <li>
                  <strong>Raiffeisen Gateway:</strong> bezbedni sistem za online
                  plaćanje kartičnim putem (Visa, MasterCard, Maestro, Dina).
                  Raiffeisen banka je PCI DSS sertifikovana i koristi najviše
                  standarde zaštite platnih podataka sa 3D Secure verifikacijom.
                </li>
                <li>
                  <strong>Email servisi:</strong> za slanje sistemskih
                  obaveštenja, potvrda plaćanja i podršku
                </li>
                <li>
                  <strong>JSON Web Tokens (JWT):</strong> za sigurnu
                  autentifikaciju korisnika
                </li>
                <li>
                  <strong>bcryptjs:</strong> za enkripciju lozinki korisnika
                </li>
                <li>
                  <strong>Sequelize ORM:</strong> za sigurno upravljanje bazom
                  podataka
                </li>
              </ul>
              <p>
                Svi treći provajderi su pažljivo odabrani na osnovu njihovih
                bezbednosnih standarda i poštovanja GDPR regulative. Raiffeisen
                banka je licencirana finansijska institucija pod nadzorom
                Narodne banke Srbije.
              </p>
            </TextContent>

            <SectionTitle>4. Kolačići (Cookies)</SectionTitle>
            <TextContent>
              <p>
                Koristimo kolačiće za poboljšanje vašeg iskustva na sajtu. Vrste
                kolačića koje koristimo:
              </p>
              <ul>
                <li>
                  <strong>Nužni kolačići:</strong> potrebni za osnovno
                  funkcionisanje sajta i održavanje korisničke sesije
                </li>
                <li>
                  <strong>Funkcionalni kolačići:</strong> pamte vaše preference
                  i podešavanja
                </li>
                <li>
                  <strong>Bezbednosni kolačići:</strong> koriste se za
                  autentifikaciju i zaštitu od prevara
                </li>
                <li>
                  <strong>Analitički kolačići:</strong> pomažu nam da razumemo
                  kako koristite sajt i poboljšamo ga
                </li>
                <li>
                  <strong>Kolačići platnog sistema:</strong> Raiffeisen Gateway
                  može koristiti privremene kolačiće za bezbedno procesiranje
                  transakcija
                </li>
              </ul>
              <p>
                Možete kontrolisati kolačiće kroz postavke vašeg pretraživača.
                Imajte na umu da onemogućavanje određenih kolačića može uticati
                na funkcionalnost sajta i proces plaćanja.
              </p>
            </TextContent>

            <SectionTitle>5. Vaša Prava</SectionTitle>
            <TextContent>
              <p>
                U skladu sa GDPR i Zakonom o zaštiti podataka o ličnosti
                Republike Srbije, imate sledeća prava u vezi sa vašim podacima:
              </p>
              <ul>
                <li>
                  <strong>Pravo pristupa:</strong> možete zatražiti kopiju
                  svojih podataka koji se čuvaju u našem sistemu
                </li>
                <li>
                  <strong>Pravo ispravke:</strong> možete ispraviti netačne ili
                  nepotpune podatke
                </li>
                <li>
                  <strong>Pravo brisanja:</strong> možete zatražiti brisanje
                  svojih podataka (osim onih koji se moraju čuvati po zakonu)
                </li>
                <li>
                  <strong>Pravo ograničavanja:</strong> možete ograničiti obradu
                  određenih podataka
                </li>
                <li>
                  <strong>Pravo prenosivosti:</strong> možete preneti podatke
                  drugom pružaocu usluga u mašinski čitljivom formatu
                </li>
                <li>
                  <strong>Pravo na prigovor:</strong> možete se usprotiviti
                  obradi podataka u određene svrhe
                </li>
                <li>
                  <strong>Pravo povlačenja saglasnosti:</strong> možete povući
                  saglasnost za obradu podataka u bilo kom trenutku
                </li>
              </ul>
              <p>
                <strong>Napomena:</strong> Podaci o transakcijama i finansijski
                zapisi moraju biti čuvani 10 godina u skladu sa Zakonom o
                računovodstvu Republike Srbije i ne mogu biti obrisani na
                zahtev.
              </p>
            </TextContent>

            <SectionTitle>6. Čuvanje Podataka</SectionTitle>
            <TextContent>
              <p>
                MITOVKA Beautyspot zadržava podatke u skladu sa zakonskim
                obavezama i potrebama pružanja usluga:
              </p>
              <ul>
                <li>
                  <strong>Korisnički nalozi:</strong> dok je nalog aktivan + 3
                  godine nakon brisanja (za pravne sporove)
                </li>
                <li>
                  <strong>Podaci o transakcijama i plaćanjima:</strong> 10
                  godina u skladu sa poreskim zakonodavstvom Republike Srbije i
                  Zakonom o računovodstvu (obavezno čuvanje)
                </li>
                <li>
                  <strong>Finansijski izveštaji:</strong> 10 godina u skladu sa
                  Zakonom o računovodstvu
                </li>
                <li>
                  <strong>Napredak u kursevima:</strong> trajno čuvanje za
                  potrebe izdavanja sertifikata i evidencije obrazovanja
                </li>
                <li>
                  <strong>Komunikacija (email, kontakt forme):</strong> 5 godina
                  za potrebe rešavanja sporova i dokumentacije
                </li>
                <li>
                  <strong>Tehnički logovi i sesije:</strong> maksimalno 12
                  meseci za potrebe bezbednosti i otklanjanja grešaka
                </li>
                <li>
                  <strong>JWT refresh tokeni:</strong> do isteka ili odjave
                  korisnika (maksimalno 30 dana)
                </li>
                <li>
                  <strong>Podaci o neuspelim transakcijama:</strong> 90 dana za
                  potrebe rešavanja sporova i prevencije prevara
                </li>
              </ul>
            </TextContent>

            <SectionTitle>7. Međunarodni Transfer</SectionTitle>
            <TextContent>
              <p>
                Raiffeisen banka Srbija je lokalna finansijska institucija pod
                nadzorom Narodne banke Srbije. Svi podaci o transakcijama se
                obrađuju u okviru Republike Srbije i Evropske unije.
              </p>
              <p>
                Neki od naših pružalaca usluga (email servisi, cloud hosting)
                mogu biti van Evropske unije. U takvim slučajevima, osiguravamo
                odgovarajući nivo zaštite kroz:
              </p>
              <ul>
                <li>Standardne ugovorne klauzule EU</li>
                <li>Sertifikacije privatnosti (Privacy Shield naslednici)</li>
                <li>Odgovarajuće tehničke i organizacione zaštitne mere</li>
                <li>GDPR usklađenost</li>
              </ul>
            </TextContent>

            <SectionTitle>8. Bezbednost Podataka</SectionTitle>
            <TextContent>
              <p>
                MITOVKA Beautyspot implementira robusne bezbednosne mere za
                zaštitu vaših podataka:
              </p>
              <ul>
                <li>
                  <strong>Enkripcija lozinki:</strong> bcrypt hashing sa salt
                  faktorom 12 - industrijski standard
                </li>
                <li>
                  <strong>SSL/TLS enkripcija:</strong> za sve komunikacije
                  između klijenta i servera (HTTPS protokol)
                </li>
                <li>
                  <strong>PCI DSS usklađenost:</strong> kartična plaćanja se
                  obrađuju preko Raiffeisen Gateway-a koji je PCI DSS
                  sertifikovan
                </li>
                <li>
                  <strong>3D Secure autentifikacija:</strong> dodatna zaštita
                  pri kartičnom plaćanju (Verified by Visa, MasterCard
                  SecureCode)
                </li>
                <li>
                  <strong>Tokeniziacija plaćanja:</strong> podaci o kartici se
                  ne čuvaju na našim serverima, koriste se samo tokeni
                  transakcija
                </li>
                <li>
                  <strong>JWT autentifikacija:</strong> bezbedni tokeni za
                  sesije korisnika sa ekspiracijom
                </li>
                <li>
                  <strong>UUID identifikatori:</strong> kriptografski bezbedni
                  ID-jevi korisnika
                </li>
                <li>
                  <strong>Validacija podataka:</strong> Sequelize ORM validacija
                  za sve unose i zaštita od SQL injection napada
                </li>
                <li>
                  <strong>Zaštićene rute:</strong> administratorski pristup samo
                  ovlašćenom osoblju sa multi-faktor autentifikacijom
                </li>
                <li>
                  <strong>Redovni backup:</strong> automatske dnevne kopije baze
                  podataka sa enkripcijom
                </li>
                <li>
                  <strong>Monitoring:</strong> praćenje neobičnih aktivnosti,
                  sumnjivих transakcija i pokušaja neovlašćenog pristupa
                </li>
                <li>
                  <strong>Firewall zaštita:</strong> višeslojni firewall i
                  zaštita od DDoS napada
                </li>
              </ul>
            </TextContent>

            <SectionTitle>9. Deca i Privatnost</SectionTitle>
            <TextContent>
              <p>
                Naše usluge nisu namenjene deci mlađoj od 16 godina. Svesno ne
                prikupljamo lične podatke od dece mlađe od 16 godina bez
                saglasnosti roditelja ili staratelja.
              </p>
              <p>
                Ako saznamo da smo nenamerno prikupili podatke od deteta mlađeg
                od 16 godina bez odgovarajuće saglasnosti, odmah ćemo preduzeti
                mere za brisanje tih podataka iz naših sistema.
              </p>
              <p>
                Roditelji ili staratelji mogu kontaktirati našu podršku radi
                uvida, izmene ili brisanja podataka svog deteta.
              </p>
            </TextContent>

            <SectionTitle>10. Izmene Politike</SectionTitle>
            <TextContent>
              <p>
                MITOVKA Beautyspot zadržava pravo da povremeno ažurira ovu
                politiku privatnosti kako bi odražavala izmene u našim praksama,
                tehnologijama ili zakonskim zahtevima.
              </p>
              <p>
                O značajnim promenama koje utiču na vaša prava ili način
                korišćenja vaših podataka ćemo vas obavestiti:
              </p>
              <ul>
                <li>
                  Email obaveštenjem najmanje 30 dana pre stupanja na snagu
                </li>
                <li>Istaknutim obaveštenjem na platformi</li>
                <li>Zahtevom za ponovnu saglasnost ako je potrebno</li>
              </ul>
              <p>
                Preporučujemo da redovno proveravate ovu stranicu za eventulane
                izmene. Datum poslednje izmene je uvek naveden na dnu stranice.
              </p>
              <p>
                Nastavak korišćenja naših usluga nakon stupanja izmena na snagu
                smatra se prihvatanjem ažurirane politike privatnosti.
              </p>
            </TextContent>

            <SectionTitle>11. Kontakt i Prava Poverenika</SectionTitle>
            <TextContent>
              <p>
                Za sva pitanja, zahteve ili pritužbe u vezi sa zaštitom vaših
                ličnih podataka, možete nas kontaktirati putem:
              </p>
              <ul>
                <li>Email forme na našoj platformi</li>
                <li>Kontakt stranice na sajtu</li>
              </ul>
              <p>Odgovorićemo na vaš zahtev u roku od 30 dana od prijema.</p>
              <p>
                <strong>Pravo na pritužbu:</strong> Ako niste zadovoljni načinom
                na koji postupamo sa vašim podacima, imate pravo da podnesete
                pritužbu Povereniku za informacije od javnog značaja i zaštitu
                podataka o ličnosti Republike Srbije:
              </p>
              <ul>
                <li>Adresa: Bulevar kralja Aleksandra 15, 11000 Beograd</li>
                <li>Telefon: +381 11 3408 900</li>
                <li>Email: office@poverenik.rs</li>
                <li>Web: www.poverenik.rs</li>
              </ul>
            </TextContent>

            <LastUpdated>
              <strong>Poslednja izmena:</strong> 10. februar 2026.
            </LastUpdated>
          </ContentContainer>
        </ContentSection>
      </Container>
    </MainContainer>
  );
};

export default PrivacyPolicyPage;
